import { combineReducers } from 'redux';
import { WidgetType } from 'widgets/WidgetType';
import { VolumeCurveActionPayload } from './actions';
import { VolumeCurveWidgetState } from './VolumeCurveWidgetState';
import { buildVolumeCurveConfigSlice } from './configuration/configSlice';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';
import { buildVolumeCurveComponentSlice } from 'widgets/volumeCurve/store/component/componentSlice.ts';

const { reducer: configReducer } = buildVolumeCurveConfigSlice();
const { reducer: componentReducer } = buildVolumeCurveComponentSlice();

const widgetStateReducer = combineReducers<VolumeCurveWidgetState>({
    config: configReducer,
    component: componentReducer,
});

export const volumeCurveWidgetsReducer = createWidgetsReducer<
    VolumeCurveWidgetState,
    VolumeCurveActionPayload
>(WidgetType.VOLUME_CURVE, widgetStateReducer);
